<template src="./index.html">
</template>

<script>
	import {getdata} from'./data.js'
	export default{
		props:{
			ywdiag:{
				type:Boolean,
				default:false
			},
			typecy:{
			  type:Number,
			  default:0
			},
			title:{
			  type:String,
			  default:0
			},
			list:{
				type:Array,
				default:function(){
					return []
				}
			},
			tableData:{
				type:Array,
				default:function(){
					return getdata().tableData
				}
			},
			tableDataone:{
				type:Array,
				default:function(){
					return getdata().tableDataone
				}
			},
			tableDatatwo:{
				type:Array,
				default:function(){
					return getdata().tableDatatwo
				}
			},
			tableDatathree:{
				type:Array,
				default:function(){
					return getdata().tableDatathree
				}
			}
		},
		data(){
			return{
				headData:getdata().headData,
				monthOneHeadData:getdata().monthOneHeadData,
				monthTwoHeadData:getdata().monthTwoHeadData,
				monthThreeHeadData:getdata().monthThreeHeadData,
			}
		},
		created() {
			this.$nextTick(() => {
			  this.tableHeight = document.body.scrollHeight - 470;
			  window.onresize = () => {
			    this.tableHeight = document.body.scrollHeight - 470;
			  };
			});
		},
		methods:{
			closediag(){
			  this.$emit("closediag",false)
			},
			chong(){
				this.list.quan.nsrsbh = this.list.nsrsbh
				this.list.quan.nianf =  this.list.year
				this.$emit("hzck",this.list.quan)
			},
		}
		
	}
</script>

<style>
</style>